<template lang="pug" src="./login.pug"></template>
<style lang="scss" src="./login.scss" scoped></style>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import config from '../../../config.json'

export default {
    name: 'Login',
    mixins: [validationMixin, validate],
    data: () => ({
        email: '',
        password: '',
        mailDialog: false,
        isShowGoogle: config.isShowGoogle,
        isShowFacebook: config.isShowFacebook,
        remember: false
    }),
    computed: {
        isShowMail: {
            get() {
                return this.$store.state.app.isShowMail
            },
            set(val) {
                this.$store.commit('SET_SHOW_MAIL', val)
            }
        },
        emailText: function() {
            return this.$vuetify.t(`$vuetify.pages.Login.emailText`).replace(':email', this.email)
        }
    },
    validations: {
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(6)
        }
    },
    methods: {
        loginUser: async function() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                await this.$store.dispatch('login', Object.assign({}, Object.select(this.$data, [
                    'email', 'password', 'remember'
                ])))
            }
        },
        loginFb() {
            FB.login((response) => {
                if (response.authResponse && response.authResponse.accessToken) {
                    this.$store.dispatch('socials/loginFB', response.authResponse.accessToken)
                }
            })
        },
        loginGmail() {
            this.$gapi._libraryLoad('auth2')
                .then(auth2 => {
                    auth2.init(this.$gapi.config)
                        .then(async auth2 => {
                            const auth = await auth2.isSignedIn.get()
                            if (!auth) {
                                await auth2.signIn()
                            }
                            const accessToken = await auth2.currentUser.get().getAuthResponse().id_token
                            await this.$store.dispatch('socials/loginGoogle', accessToken)
                        })
                        .catch(_ => {})
                })
        },
        sendMail() {
            if (this.$v.email.$invalid) {
                this.$v.email.$touch()
            } else {
                this.$store.dispatch('forgotPassword', {
                    email: this.email,
                    subject: this.$vuetify.t('$vuetify.pages.Login.emailSubject'),
                    text: this.$vuetify.t('$vuetify.pages.Login.forgotText')
                })
            }
        },
        closeDialog() {
            this.$store.commit('SET_SHOW_MAIL', false)
        }
    }
}
</script>
